var React = require('react');

function Mail (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("path",{"id":"a","d":"M0 0h19.444v14H0z"})),React.createElement("g",{"fill":"none","fillRule":"evenodd","key":1},[React.createElement("mask",{"id":"b","fill":"#fff","key":0},React.createElement("use",{"xlinkHref":"#a"})),React.createElement("path",{"stroke":"currentColor","strokeWidth":"1.167","d":"M.583.583h18.278v12.833H.583z","key":1}),React.createElement("path",{"stroke":"currentColor","strokeWidth":"1.167","mask":"url(#b)","d":"M0 .778l9.722 8.555L19.444.778","key":2})])]);
}

Mail.defaultProps = {"width":"20","height":"14"};

module.exports = Mail;

Mail.default = Mail;
